import { ReactNode } from 'react';
import { Box, BoxProps } from '@bitrise/bitkit';

interface Props extends BoxProps {
  children: ReactNode;
  leftAligned?: boolean;
}

const ContentWrapper = ({ children, leftAligned, ...rest }: Props): JSX.Element => {
  return (
    <Box width="100%" maxWidth="101rem" marginX={leftAligned ? '0' : 'auto'} paddingX={['16', '32']} {...rest}>
      {children}
    </Box>
  );
};

export default ContentWrapper;
